import { KeyboardEvent } from 'react';
import { isElectron } from './platform';

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const handleEnterPress =
  (callback?: () => void) => (e: KeyboardEvent) => {
    if (e.key === 'Enter' && callback) {
      e.stopPropagation();
      callback();
    }
  };

export const getCountryCode = (country?: string) => {
  // TODO
  if (country === 'US') {
    return '+1';
  }
  return '+44';
};

export const isWindows = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('win') && !ua.includes('windows phone');
};

export const isMac = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('mac');
};

// FIXME change when we enable this for browser
export const isVcrmSupportedOs = () => isElectron() && (isWindows() || isMac());

export const getSha256Hash = async (message: string) => {
  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};
